import { createAction, createAsyncAction } from 'typesafe-actions';

import { AlertConfig } from '../types';
import {
  FetchSimulationCubeSuccessPayload,
  SimulationCubeFilters,
  SimulationRunEstimate,
  SimulationRunStatus,
} from './types';

export const setSelectedDate       = createAction('flCashConsumption/setSelectedDate')<string>();
export const setAlertConfig        = createAction('flCashConsumption/setAlertConfig')<AlertConfig>();
export const setSimulationProgress = createAction('flCashConsumption/setSimulationProgress')<number | null>();
export const setSimulationRunStatus = createAction('flCashConsumption/setSimulationRunStatus')<SimulationRunStatus>();
export const setSimulationRunEstimate = createAction('flCashConsumption/setSimulationRunEstimate')<SimulationRunEstimate | null>();
export const setSimulationRunEstimating = createAction('flCashConsumption/setSimulationRunEstimating')<boolean>();
export const setConfirmationModalOpen = createAction('flCashConsumption/setConfirmationModalOpen')<boolean>();
export const setLastRequestPayload = createAction('flCashConsumption/setLastRequestPayload')<SimulationCubeFilters | null>();
export const setSimulationRunStarting = createAction('flCashConsumption/setSimulationRunStarting')<boolean>();
export const clearRunState = createAction('flCashConsumption/clearRunState')();

export const fetchSimulationCube = createAsyncAction(
  'flCashConsumption/fetchSimulationCube/request',
  'flCashConsumption/fetchSimulationCube/success',
  'flCashConsumption/fetchSimulationCube/failure',
)<SimulationCubeFilters | undefined, FetchSimulationCubeSuccessPayload, undefined>();
